import { pagination, productVariants } from './resolvers';
import {
  sidebarModelSpecificationId,
  sidebarComponentId,
  isUserLoggedIn,
  organizationProductsFilters,
  sharedProductsFilters,
  assigningSharedProductsFilters,
  assigningMyProductsFilters,
  organizationSuppliersFilters,
  organizationOrderOperatorsFilters,
} from './cache';

export default {
  Query: {
    fields: {
      sidebarComponentId: {
        read() {
          return sidebarComponentId();
        },
      },
      sidebarModelSpecificationId: {
        read() {
          return sidebarModelSpecificationId();
        },
      },
      isUserLoggedIn: {
        read() {
          return isUserLoggedIn();
        },
      },
    },
  },
  UserNode: {
    fields: {
      modelSpecifications: pagination,
      modelSpecificationsSharedWith: pagination,
      timings: pagination,
      organizationProductsFilters: {
        read() {
          return organizationProductsFilters();
        },
      },
      sharedProductsFilters: {
        read() {
          return sharedProductsFilters();
        },
      },
      organizationSuppliersFilters: {
        read() {
          return organizationSuppliersFilters();
        },
      },
      organizationOrderOperatorsFilters: {
        read() {
          return organizationOrderOperatorsFilters();
        },
      },
    },
  },
  ProductNode: {
    fields: {
      variants: {
        keyArgs: ['status', 'colorId'],
        ...pagination,
      },
    },
  },
  TenantNode: {
    fields: {
      brands: pagination,
      categories: pagination,
      seasons: pagination,
      sizes: pagination,
      elements: {
        keyArgs: ['name'],
        ...pagination,
      },
      templates: {
        keyArgs: ['name'],
        ...pagination,
      },
      suppliers: {
        keyArgs: ['name', 'status', 'isPublic', 'products_CategoryId'],
        ...pagination,
      },
      products: {
        keyArgs: ['id', 'name', 'categoryId', 'supplierId', 'status'],
        ...pagination,
      },
      timingTasks: {
        keyArgs: ['id', 'type_Code', 'name', 'category'],
        ...pagination,
      },
      orderOperators: {
        keyArgs: ['name'],
        ...pagination,
      },
    },
  },
  TimingTaskNode: {
    fields: {
      type: {
        merge(existing, incoming) {
          return { ...existing, ...incoming };
        },
      },
    },
  },
  TimingFolderNode: {
    fields: {
      timings: pagination,
    },
  },
  TimingNode: {
    fields: {
      items: pagination,
    },
  },
  ComponentNode: {
    assigningSharedProductsFilters: {
      read() {
        return assigningSharedProductsFilters();
      },
    },
    assigningMyProductsFilters: {
      read() {
        return assigningMyProductsFilters();
      },
    },
  },
  Autocomplete: {
    fields: {
      productVariants,
      unassignedProducts: {
        keyArgs: ['categoryId', 'name', 'supplierId', 'id'],
        ...pagination,
      },
      timingTasks: pagination,
      modelSpecificationTemplateElements: pagination,
      modelSpecificationTemplates: pagination,
    },
  },
};
